export default "/images/Papier.webp?6389b6882db04784d9040320e55bca7b";